import { Component } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  Pagination,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import PageItem from "react-bootstrap/PageItem";
import Table from "react-bootstrap/Table";
import { getRequestByAuth } from "../../../../function/helper";
import "./messagesTableList.css";
import ReadTicketButton from "./components/ticket/ReadTicketButton";

export default class MessagesTablePage extends Component {
  state = {
    users: [],
    showNumber: 10,
    pageNumber: 1,
    searchText: "",
    active: 1,
    items: [],
    paginationlength: 1,
    startNumber: 0,
    showModalDetail: false,
    detailTicket: {},
    loading: false,
  };

  async getData() {
    this.setState({ loading: true });
    const datas = await getRequestByAuth(
      `/setting/v1/ticket/all?numberpage=${this.state.pageNumber}&numberitems=${this.state.showNumber}`
    );
    this.setState({ loading: false });

    if (datas && datas.status === 200) {
      this.setState(
        {
          users: datas.data.all,
          paginationlength: datas.data.number,
          startNumber: (this.state.pageNumber - 1) * this.state.showNumber + 1,
        },
        () => {
          this.setPaginate();
        }
      );
    }
  }

  setInputNumber = event => {
    this.setState({ showNumber: event.target.value }, () => {
      this.getData();
    });
  };

  setInput = event => {
    this.setState({ searchText: event.target.value, pageNumber: 1 }, () => {
      this.getData();
    });
  };

  changePageNumber(number) {
    this.setState({ pageNumber: number, active: number }, () => {
      this.getData();
    });
  }

  componentDidMount() {
    this.getData();
  }

  paginationClicked = event => {
    const itemClicked = event.target.text;
    this.setState({ pageNumber: itemClicked, active: itemClicked }, () => {
      this.getData();
    });
  };

  setPaginate() {
    this.setState({ items: [] }, () => {
      const newItem = [];
      if (this.state.pageNumber < 4) {
        if (this.state.paginationlength < 6) {
          for (let j = 0; j < this.state.paginationlength; j++) {
            if (this.state.pageNumber == j + 1) {
              newItem.push(<PageItem active>{j + 1}</PageItem>);
            } else {
              newItem.push(
                <PageItem onClick={event => this.paginationClicked(event)}>
                  {j + 1}
                </PageItem>
              );
            }
          }
        } else {
          for (let j = 0; j < 6; j++) {
            if (this.state.pageNumber == j + 1) {
              newItem.push(<PageItem active>{j + 1}</PageItem>);
            } else {
              newItem.push(
                <PageItem onClick={event => this.paginationClicked(event)}>
                  {j + 1}
                </PageItem>
              );
            }
          }
        }
      } else if (
        parseInt(this.state.paginationlength) - 3 <
          parseInt(this.state.pageNumber) &&
        parseInt(this.state.pageNumber) <= parseInt(this.state.paginationlength)
      ) {
        for (
          let j = parseInt(this.state.paginationlength) - 6;
          j < parseInt(this.state.paginationlength);
          j++
        ) {
          if (parseInt(this.state.pageNumber) == j + 1) {
            newItem.push(<PageItem active>{j + 1}</PageItem>);
          } else {
            newItem.push(
              <PageItem onClick={event => this.paginationClicked(event)}>
                {j + 1}
              </PageItem>
            );
          }
        }
      } else {
        for (
          let j = parseInt(this.state.pageNumber) - 3;
          j < parseInt(this.state.pageNumber) + 3;
          j++
        ) {
          if (parseInt(this.state.pageNumber) == j + 1) {
            newItem.push(<PageItem active>{j + 1}</PageItem>);
          } else {
            newItem.push(
              <PageItem onClick={event => this.paginationClicked(event)}>
                {j + 1}
              </PageItem>
            );
          }
        }
      }

      this.setState({ items: newItem }, () => {});
    });
  }

  showDetailInModal(index) {
    this.setState({ showModalDetail: true });
    this.setState({ detailTicket: this.state.users[index].item });
  }

  onRead(ticketId) {
    const users = this.state.users.map(user => {
      if (user.item.id === ticketId) {
        user.item.isReadAnswer = 1;
      }

      return user;
    });

    this.setState({ users });
  }

  render() {
    const table = (
      <div className="w-100 px-1 overflow-x-auto">
        <Table striped bordered={true} className="w-100">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره تیکت</th>
              <th>موضوع پیام</th>
              <th>وضعیت</th>
              <th>جزییات</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {this.state.users.map((user, index) => (
              <tr key={index}>
                <td>{index + this.state.startNumber}</td>
                <td>{user.item.id}</td>
                <td>{user.item.subject}</td>
                <td>{user.item.status}</td>
                <td title="مشاهده جزئیات تیکت">
                  <ReadTicketButton
                    isReadAnswer={user.item.isReadAnswer}
                    ticketId={user.item.id}
                    onRead={() => {
                      this.onRead(user.item.id);
                    }}
                    onClick={() => {
                      this.showDetailInModal(index);
                    }}
                  />
                </td>
                <td>
                  {user.date} - {user.time}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );

    const optionArew = (
      <div className="d-flex flex-wrap row-gap-2 py-3">
        <Col xs={12} sm={6} lg={4} xl={3} className="px-2">
          <Form.Label>تعداد نمایش:</Form.Label>
          <Form.Select id="disabledSelect" onChange={this.setInputNumber}>
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
          </Form.Select>
        </Col>
      </div>
    );

    const paginate = (
      <Pagination dir="ltr" className="m-4">
        {this.state.items}
      </Pagination>
    );

    return (
      <Container>
        <h4 className="text-secondary">لیست تیکت ها</h4>
        <hr />
        <Card className="tableOption w-100">
          {optionArew}
          {this.state.loading ? (
            <div className="text-center">
              <div className="spinner-border" role="status"></div>
            </div>
          ) : (
            table
          )}
          {paginate}
        </Card>
        <Modal
          show={this.state.showModalDetail}
          direction="rtl"
          size="xl"
          onHide={() => this.setState({ showModalDetail: false })}
          centered
          className="modal-bootstrap"
        >
          <Modal.Header>
            <h4 className="rtl">جزئیات تیکت</h4>
          </Modal.Header>
          <Modal.Body
            className=""
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <p className="m-0">
              <strong>موضوع تیکت:</strong>
              <span> {this.state.detailTicket.subject}</span>
            </p>

            <p className="m-0">
              <strong>وضعیت پیام:</strong>
              <span> {this.state.detailTicket.status}</span>
            </p>

            <p className="m-0">
              <strong>بخش مربوطه:</strong>
              <span>{this.state.detailTicket.Handlingunit}</span>
            </p>

            <p className="m-0">
              <strong>درجه اهمیت:</strong>
              <span>{this.state.detailTicket.importance}</span>
            </p>

            <p className="m-0">
              <strong>تیکت برای:</strong>
              <span>{this.state.detailTicket.typeTicket}</span>
            </p>

            <p className="m-0">
              <strong>شماره بارنامه:</strong>
              <span>{this.state.detailTicket.numberParcel}</span>
            </p>

            <p className="m-0">
              <strong>شرح:</strong>
              <span style={{ whiteSpace: "pre-line" }}>
                {this.state.detailTicket.message}
              </span>
            </p>

            <hr />

            <p className="m-0">
              <strong className="d-block">پاسخ:</strong>
              <strong style={{ whiteSpace: "pre-line" }}>
                {this.state.detailTicket.answer
                  ? this.state.detailTicket.answer
                  : "پیام شما هنوز پاسخ داده نشده است."}
              </strong>
            </p>
          </Modal.Body>
          <Modal.Footer className="d-flex align-item-center justify-content-center">
            <Button
              className="btn-cancel-style"
              onClick={() => this.setState({ showModalDetail: false })}
            >
              فهمیدم
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}
